export default __webpack_public_path__ + "static/soccer-8baa16b0a50cb9f054c7b95ab86644db.jpg";